<template>
  <div class="activate-page">
    <!-- <div class="mp-nav">
      <span class="back-btn" @click="goBack">
        <van-icon name="arrow-left" />
      </span>
      <span class="nav-title">设备激活</span>
    </div> -->

    <div class="form-section">
      <!-- 客户信息 -->
      <div class="form-card">
        <div class="section-title">客户信息</div>
        <van-field
          v-model="form.customerName"
          label="客户姓名"
          placeholder="请输入客户姓名"
          required
          :rules="[{ required: true, message: '请输入客户姓名' }]"
        />
        <van-field
          v-model="form.customerPhone"
          label="客户电话"
          placeholder="请输入客户手机号"
          type="tel"
          required
          :rules="[{ required: true, message: '请输入客户手机号' }]"
        />
      </div>

      <!-- 扫描串号 -->
      <div class="form-card">
        <div class="section-title">扫描串号</div>
        <!-- <div class="scan-guide">
          请扫描设备背面或包装盒上的 <strong>IMEI1</strong> 条码
        </div> -->
        <div class="scan-row">
          <van-field
            v-model="form.imei"
            label="IMEI1串号"
            placeholder="请扫描或输入IMEI1号"
            required
            class="imei-field"
          />
          <!-- <van-button
            size="small"
            type="info"
            class="scan-btn"
            @click="scanImei"
          >
            扫码
          </van-button> -->
        </div>
        <div class="imei-tip">请确保扫描的是 IMEI1（非IMEI2），否则校验可能失败</div>
      </div>

      <my-button @click.native="submitVerify" :loading="loading">校验并激活</my-button>

      <!-- <div class="flow-note">
        <div class="note-title">激活流程：</div>
        <div>① 店员填写客户姓名、电话</div>
        <div>② 扫描设备IMEI1（引导扫描IMEI1）</div>
        <div>③ 系统校验IMEI是否在待生效列表中</div>
        <div>④ 校验通过 → 展示激活结果和产品升级选项</div>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'Activate',
  data() {
    return {
      loading: false,
      form: {
        customerName: '',
        customerPhone: '',
        imei: '',
      },
    }
  },
  methods: {
    goBack() {
      this.$router.push({ path: '/Oppo/ClerkHome' })
    },
    scanImei() {
      if (!window.wx) {
        this.$toast('暂不支持扫码，请手动输入IMEI')
        return
      }
      window.wx.scanQRCode({
        needResult: 1,
        scanType: ['barCode'],
        success: (res) => {
          this.form.imei = res.resultStr
        },
      })
    },
    submitVerify() {
      if (!this.form.customerName) {
        this.$toast('请输入客户姓名')
        return
      }
      if (!this.form.customerPhone) {
        this.$toast('请输入客户手机号')
        return
      }
      if (!this.form.imei) {
        this.$toast('请扫描或输入IMEI1号')
        return
      }
      this.loading = true
      this.$http.oppoCheckDevice({
        name: this.form.customerName,
        phone: this.form.customerPhone,
        imei: this.form.imei,
      }).then((res) => {
        const checkData = res && res.data
        const orderId = checkData && checkData.order_id
        if (!orderId) {
          this.$toast('校验失败，IMEI不在待生效列表中')
          return
        }
        sessionStorage.setItem('oppoCheckDeviceInfo', JSON.stringify(checkData))
        this.$router.push({ path: '/Oppo/DeviceInfo', query: { order_id: orderId } })
      }).catch((err) => {
        this.$toast((err && err.msg) || '校验失败，IMEI不在待生效列表中')
      }).finally(() => {
        this.loading = false
      })
    },
  },
}
</script>

<style lang="less" scoped>
.activate-page {
  min-height: 100vh;
  background: #f5f5f5;

  .mp-nav {
    position: sticky;
    top: 0;
    z-index: 10;
    display: flex;
    align-items: center;
    height: 88px;
    background: #fff;
    padding: 0 32px;
    border-bottom: 1px solid #f0f0f0;

    .back-btn {
      font-size: 36px;
      color: #333;
      margin-right: 20px;
      cursor: pointer;
    }

    .nav-title {
      font-size: 34px;
      font-weight: 600;
      color: #1a1a1a;
    }
  }

  .form-section {
    padding: 24px;

    .form-card {
      background: #fff;
      border-radius: 16px;
      padding: 30px 0 10px;
      margin-bottom: 20px;
      overflow: hidden;

      .section-title {
        font-size: 30px;
        font-weight: 600;
        color: #1a1a1a;
        padding: 0 30px 20px;
        border-bottom: 1px solid #f5f5f5;
        margin-bottom: 10px;
      }
    }

    .scan-guide {
      margin: 0 30px 16px;
      background: #fff7e6;
      border-left: 4px solid #fa8c16;
      border-radius: 0 8px 8px 0;
      padding: 16px 20px;
      font-size: 26px;
      color: #d46b08;
      line-height: 1.6;
    }

    .scan-row {
      display: flex;
      align-items: center;
      padding-right: 24px;

      .imei-field {
        flex: 1;
      }

      .scan-btn {
        flex-shrink: 0;
        margin-left: 16px;
        height: 64px;
        font-size: 26px;
      }
    }

    .imei-tip {
      font-size: 22px;
      color: #fa8c16;
      padding: 10px 30px 20px;
      line-height: 1.5;
    }

    .flow-note {
      background: #f0f5ff;
      border-left: 4px solid #1890ff;
      border-radius: 0 8px 8px 0;
      padding: 20px 24px;
      font-size: 24px;
      color: #0050b3;
      line-height: 2;
      margin-top: 20px;

      .note-title {
        font-weight: 600;
        margin-bottom: 4px;
      }
    }
  }
}
</style>
